import React from 'react'
import { IFormProps } from '../../lib/types'
import { GLogin } from '../login/google-login-container'
import { FormikProps, Formik } from 'formik'
import { Input, GoogleReCaptcha } from '../../lib/components'
import { Link } from 'react-router-dom'

const LoginV2Presenter = ({
  initialValues,
  handleFormSubmit,
  validationSchema,
  reRef,
  googleLoginHandler,
}: IFormProps) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
    >
      {(formik) => {
        const {
          values,
          touched,
          errors,
          dirty,
          handleChange,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }: FormikProps<typeof initialValues> = formik
        const canSubmit = values.email?.trim() && values.password
        const buttonClass = isSubmitting
          ? 'login-page__btn-primary login-page__btn-primary--loading'
          : canSubmit
          ? 'login-page__btn-primary login-page__btn-primary--enabled'
          : 'login-page__btn-primary login-page__btn-primary--disabled'

        return (
          <>
            <form className='login-page__form' onSubmit={handleSubmit} noValidate>
              <div className='mt-14'>
                <Input
                  labelText='Email address'
                  name='email'
                  placeholder='Enter your email'
                  type='text'
                  data-testid='email-input'
                  required
                  value={values.email}
                  handleChange={handleChange(initialValues.email)}
                  dirty={dirty}
                  errors={{ email: !!errors && errors.email ? errors.email : null }}
                  touched={{ email: !!touched && !!touched.email }}
                />
              </div>

              <div className='mt-14'>
                <Input
                  labelText='Password'
                  name='password'
                  placeholder='Enter your password'
                  required
                  type='password'
                  data-testid='password-input'
                  value={values.password}
                  handleChange={handleChange(initialValues.password)}
                  dirty={dirty}
                  errors={{
                    password: !!errors && errors.password ? errors.password : null,
                  }}
                  touched={{ password: !!touched && !!touched.password }}
                />
              </div>

              <div className='login-page__forgot-mobile-wrap'>
                <Link
                  className='login-page__link login-page__link--primary'
                  to='/forgot-password'
                  data-testid='forgot-password-link-mobile'
                >
                  Forgot Password?
                </Link>
              </div>

              <GoogleReCaptcha
                handleChange={(value) => setFieldValue('reCaptchaToken', value)}
                reCaptchaRef={reRef}
                size='invisible'
              />

              <button
                type='submit'
                className={`${buttonClass} mt-24 mb-24`}
                disabled={isSubmitting}
                data-testid='login-button'
              >
                {isSubmitting ? (
                  <>
                    <span className='login-page__spinner' aria-hidden />
                    Login...
                  </>
                ) : (
                  'Login'
                )}
              </button>

              <div className='login-page__divider'>
                <span className='login-page__divider-text'>Or continue with</span>
              </div>

              {googleLoginHandler && (
                <div className='login-page__google-wrap'>
                  <GLogin
                    buttonText='Continue with Google'
                    onFailure={(res) => console.log('Login Failed ', res)}
                    onSuccess={(res) => googleLoginHandler(res, !!values.rememberMe)}
                  />
                </div>
              )}

              <div className='login-page__links'>
                <Link className='login-page__link' to='/signup' data-testid='create-account-link'>
                  Create account
                </Link>
                <Link
                  className='login-page__link login-page__link--primary'
                  to='/forgot-password'
                  data-testid='forgot-password-link'
                >
                  Forgot Password?
                </Link>
              </div>
            </form>
          </>
        )
      }}
    </Formik>
  )
}

export { LoginV2Presenter }
